import React from 'react';
import { Phone } from 'lucide-react';
import { Button } from '../ui/button';
import { locations } from '../../data/site';

export const InnerHeroActions = ({ page }) => (
  <div className="reference-actions inner-hero-actions" data-testid={`${page}-hero-actions`}>
    {locations.map((location, index) => (
      <Button asChild className={`brand-button ${index ? 'outline-button' : ''}`} key={location.id}>
        <a href={location.tel} data-testid={`${page}-hero-call-${location.id}`}>
          <Phone size={17} aria-hidden="true" />Call {location.name} · {location.phone}
        </a>
      </Button>
    ))}
  </div>
);

export const InnerHeroTrust = ({ page }) => (
  <div className="hero-trust" data-testid={`${page}-hero-trust`}>
    <span data-testid={`${page}-hero-rating`}><span className="review-stars" aria-label="5 stars">★★★★★</span> <b>4.9</b> on Google</span>
    <span data-testid={`${page}-hero-review-count`}><b>130+</b> verified reviews</span>
    <span data-testid={`${page}-hero-shop-count`}><b>2</b> El Paso shops</span>
    <span data-testid={`${page}-hero-days`}>Open <b>6 days</b> a week</span>
  </div>
);